/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useState, useEffect } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import styles from "./index.module.css";
import { DropzoneDialog } from "material-ui-dropzone";
import { useNotification } from "context/NotificationContext";

//import files images
import excel from "assets/images/file-icons/excel.png";
import folder from "assets/images/file-icons/folder.png";
import image from "assets/images/file-icons/image.png";
import music from "assets/images/file-icons/music.png";
import pdf from "assets/images/file-icons/pdf.png";
import text from "assets/images/file-icons/text.png";
import word from "assets/images/file-icons/word.png";
import zip from "assets/images/file-icons/zip.png";

const apiUrl = process.env.REACT_APP_AUTH_API_URL;

const FileSystem = ({ userId, subfolder, isAdmin }) => {
  const [path, setPath] = useState([subfolder]);
  const [files, setFiles] = useState({});
  const [contextMenuVisible, setContextMenuVisible] = useState(false);
  const [contextMenuAnchor, setContextMenuAnchor] = useState(null);
  const [contextFileSelected, setContextFileSelected] = useState(null);
  const [modalUploadOpen, setModalUploadOpen] = useState(false);
  const { showNotification } = useNotification();

  useEffect(() => {
    downloadFiles();
  }, [path]);

  const downloadFiles = async () => {
    const currentPath = path.join("/");
    const response = await fetch(`${apiUrl}/file_list.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ user_id: userId, path: currentPath, is_admin: isAdmin }),
    });
    const result = await response.json();
    setFiles(result.message);
  };

  const goBack = (index) => {
    if (index === path.length - 1) return;
    const newPath = path.slice(0, index + 1);
    setPath(newPath);
  };

  const openFolder = (file) => {
    setPath([...path, file]);
  };

  const openContextMenu = (event, file = null) => {
    event.preventDefault();
    event.stopPropagation();
    if (contextMenuVisible) {
      closeContextMenu();
      return;
    }
    setContextMenuAnchor({
      left: event.clientX + 2,
      top: event.clientY - 6,
    });
    setContextMenuVisible(true);
    setContextFileSelected(file);
  };

  const closeContextMenu = () => {
    setContextMenuVisible(false);
    setContextFileSelected(null);
  };

  const deleteFile = async () => {
    closeContextMenu();
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("path", `${path.join("/")}/${contextFileSelected}`);
    formData.append("is_admin", isAdmin);

    await fetch(`${apiUrl}/file_delete.php`, {
      method: "POST",
      body: formData,
    });

    downloadFiles();
  };

  const createFolder = async () => {
    const name = prompt("Nome cartella");
    closeContextMenu();
    if (!name) return;
    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("path", path.join("/"));
    formData.append("name", name);
    formData.append("is_admin", isAdmin);
    await fetch(`${apiUrl}/file_create_folder.php`, {
      method: "POST",
      body: formData,
    });
    downloadFiles();
  };

  const renameFile = async () => {
    const oldName = contextFileSelected;
    const oldExtension = oldName.split(".").pop();

    let newName = prompt("Rinomina file", oldName);
    closeContextMenu();
    if (!newName) return;

    // Ensure the new name does not change the extension
    if (newName.split(".").pop() !== oldExtension) {
      showNotification({
        color: "error",
        icon: <Icon>error</Icon>,
        title: "Errore",
        dateTime: new Date().toLocaleString(),
        content: "L'estensione del file non può essere modificata.",
      });
      return;
    }

    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("path", path.join("/"));
    formData.append("name", newName);
    formData.append("oldName", oldName);
    formData.append("is_admin", isAdmin);

    await fetch(`${apiUrl}/file_rename.php`, {
      method: "POST",
      body: formData,
    });

    downloadFiles();
  };

  const uploadFiles = async (files) => {
    const formData = new FormData();
    formData.append("path", path.join("/"));
    formData.append("user_id", userId);
    formData.append("is_admin", isAdmin);
    files.forEach((file) => {
      formData.append("file[]", file);
    });
    await fetch(`${apiUrl}/file_upload.php`, {
      method: "POST",
      body: formData,
    });
    downloadFiles();
  };

  const renderFileSystem = (files) => {
    const arr = [];
    if (files.directory) {
      files.directory.forEach((el, index) => {
        arr.push(renderFolder(el, index));
      });
    }
    if (files.files) {
      files.files.forEach((el, index) => {
        arr.push(renderFile(el, index));
      });
    }
    return <Grid container>{arr}</Grid>;
  };

  const renderFolder = (file, index) => (
    <button
      onContextMenu={(event) => openContextMenu(event, file)}
      className={styles.folder}
      key={`folder-${index}`}
      onDoubleClick={() => openFolder(file)}
    >
      <img src={folder} />
      <div className={styles.folderName}>{file}</div>
    </button>
  );

  const downloadFile = (file) => {
    const fileUrl = `${apiUrl}/uploads/${userId}/${path}/${file}`;
    const anchor = document.createElement("a");
    anchor.href = fileUrl;
    anchor.download = file;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const renderFile = (file, index) => (
    <button
      onContextMenu={(event) => openContextMenu(event, file)}
      className={styles.folder}
      key={`file-${index}`}
      onDoubleClick={() => downloadFile(file)}
    >
      <img src={renderFileIcon(file.split(".").pop())} />
      <div className={styles.folderName}>{file}</div>
    </button>
  );

  const renderFileIcon = (ext) => {
    switch (ext.toUpperCase()) {
      case "PDF":
        return pdf;
      case "DOC":
      case "DOCX":
        return word;
      case "MP3":
      case "WAV":
        return music;
      case "RAR":
      case "ZIP":
        return zip;
      case "CSV":
      case "XML":
      case "XLS":
      case "XLSX":
        return excel;
      case "EXE":
      case "TTF":
        return text;
      case "PNG":
      case "GIF":
      case "JPEG":
      case "JPG":
        return image;
      case "TXT":
        return text;
      default:
        return text;
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <Breadcrumbs>
          {path.map((el, index) => (
            <button
              className={styles.breadcrumbs}
              key={`breadcrumbs-${index}`}
              onClick={() => goBack(index)}
            >
              <MDTypography
                textTransform="uppercase"
                opacity={index === path.length - 1 ? 1 : 0.5}
                variant="button"
                fontWeight="bold"
              >
                {index === 0 ? "Home" : el}
              </MDTypography>
            </button>
          ))}
        </Breadcrumbs>
        <MDButton color="primary" onClick={() => setModalUploadOpen(true)}>
          <Icon style={{ marginRight: 10 }}>upload</Icon>
          Carica File
        </MDButton>
      </div>

      <div onContextMenu={(event) => openContextMenu(event)} className={styles.filesContainer}>
        {renderFileSystem(files)}

        <Menu
          open={contextMenuVisible}
          onClose={closeContextMenu}
          anchorReference="anchorPosition"
          anchorPosition={contextMenuAnchor}
        >
          {isAdmin && (
            <MenuItem onClick={createFolder}>
              <ListItemIcon>
                <Icon fontSize="medium">create_new_folder</Icon>
              </ListItemIcon>
              <ListItemText>
                <MDTypography variant="button">Nuova Cartella</MDTypography>
              </ListItemText>
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              setModalUploadOpen(true);
              closeContextMenu();
            }}
          >
            <ListItemIcon>
              <Icon fontSize="medium">cloud_upload</Icon>
            </ListItemIcon>
            <ListItemText>
              <MDTypography variant="button">Carica File</MDTypography>
            </ListItemText>
          </MenuItem>

          {contextFileSelected && (
            <>
              <MenuItem onClick={renameFile}>
                <ListItemIcon>
                  <Icon fontSize="medium">edit</Icon>
                </ListItemIcon>
                <ListItemText>
                  <MDTypography variant="button">Rinomina</MDTypography>
                </ListItemText>
              </MenuItem>
              <MenuItem onClick={deleteFile}>
                <ListItemIcon>
                  <Icon fontSize="medium">remove_circle</Icon>
                </ListItemIcon>
                <ListItemText>
                  <MDTypography variant="button">Elimina</MDTypography>
                </ListItemText>
              </MenuItem>
            </>
          )}
        </Menu>
      </div>

      <DropzoneDialog
        cancelButtonText="Annulla"
        submitButtonText="Invia"
        open={modalUploadOpen}
        onClose={() => setModalUploadOpen(false)}
        onSave={(files) => {
          uploadFiles(files);
          setModalUploadOpen(false);
        }}
        showPreviews={true}
        showFileNamesInPreview={true}
        filesLimit={100}
        maxFileSize={3000000000}
      />
    </>
  );
};

FileSystem.defaultProps = {
  subfolder: "",
};

export default FileSystem;
